exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: diablo) {\n.icon-text {\n    font-size: 0.37333rem;\n    color: #cfcfd0;\n}\n}", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-minibar/diablo.css"],"names":[],"mappings":";AAAA;AACE;IACE,sBAAgB;IAChB,eAAe;CAChB;CACF","file":"diablo.css","sourcesContent":["@media screen and (weex-theme: diablo) {\n  .icon-text {\n    font-size: 28px;\n    color: #cfcfd0;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f607d5d2","scoped":false,"hasInlineConfig":false}!./packages/dof-minibar/diablo.css
// module id = 272
// module chunks = 0 1